<template>
  <LocationFinderSelect v-model="select"
                        :select="false"
                        :inverted="true" />
</template>
<script setup>
import { ref } from 'vue';
import LocationFinderSelect from './components/fields/LocationFinderSelect.vue';
const select = ref('');
</script>